// For Service PresetAssociation

import { useNuxtApp } from '#app';
import { BaseService } from '../base/base.service';
import type { IModelResponse } from '../base/dto/base.dto';
import {
  ModelDepartment,
  ModelDrive,
  ModelDriveItem,
  ModelGETPresetAssociationPreset,
  ModelPresetActive,
  ModelSharePoint,
  ModelSharePointIndexing,
  ModelSite,
  ModelUser,
  type IModelGETPresetAssociationPresetResponse,
} from './dto/preset-asso.dto';
import { PresetAssociationRepository } from './preset-asso.repository';

export class PresetAssociationService extends BaseService {
  private presetAssociationRepository = new PresetAssociationRepository(
    this.api,
    this.configService
  );

  async getPresetAssociationPreset(
    id: string
  ): Promise<ModelGETPresetAssociationPreset> {
    const { $functions } = useNuxtApp();
    let dataResult = new ModelGETPresetAssociationPreset();

    try {
      const res =
        await this.presetAssociationRepository.getPresetAssociationPreset(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETPresetAssociationPreset(resData.data);
        console.log('getPresetAssociationPreset', id, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async postPresetAssociationPreset(params: FormData): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res =
        await this.presetAssociationRepository.postPresetAssociationPreset(
          params
        );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = resData.data;
        console.log('postPresetAssociationPreset', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async putPresetAssociationPreset(params: FormData): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res =
        await this.presetAssociationRepository.putPresetAssociationPreset(
          params
        );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = resData.data;
        console.log('putPresetAssociationPreset', resData.data, dataResult);
      }
    } catch (err: any) {
      // $functions.notify.error({
      //   text: err.message,
      // });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async putPresetAssociationPresetDuplication(
    params: FormData
  ): Promise<ModelGETPresetAssociationPreset> {
    const { $functions } = useNuxtApp();
    let dataResult = new ModelGETPresetAssociationPreset();

    try {
      const res =
        await this.presetAssociationRepository.putPresetAssociationPresetDuplication(
          params
        );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelGETPresetAssociationPreset(resData.data);
        console.log(
          'putPresetAssociationPresetDuplication',
          resData.data,
          dataResult
        );
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async getPresetAssociationPresetActive(
    params: any
  ): Promise<ModelPresetActive[]> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelPresetActive[] = [];

    try {
      const res =
        await this.presetAssociationRepository.getPresetAssociationPresetActive(
          params
        );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map((e) => new ModelPresetActive(e));
        console.log(
          'getPresetAssociationPresetActive',
          resData.data,
          dataResult
        );
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async getSiteList(params: any): Promise<IModelResponse<ModelSite[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelSite[]> = {
      data: [],
    };

    try {
      const res = await this.presetAssociationRepository.getSiteList(params);
      const resData = res.data.value;
      dataResult = (resData.sites || []).map((e: any) => new ModelSite(e));
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }
    return dataResult;
  }

  async getDriveList(siteId: any): Promise<IModelResponse<ModelDrive[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelDrive[]> = {
      data: [],
    };

    try {
      const res = await this.presetAssociationRepository.getDriveList(siteId);
      const resData = res.data.value;

      dataResult = (resData?.value || []).map((e: any) => new ModelDrive(e));
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }
    return dataResult;
  }

  async getDriveItemList(
    siteId: any,
    driveId: any
  ): Promise<IModelResponse<ModelDriveItem[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelDriveItem[]> = {
      data: [],
    };

    try {
      const res = await this.presetAssociationRepository.getDriveItemList(
        siteId,
        driveId
      );
      const resData = res.data.value;

      dataResult = (resData.value || []).map((e: any) => new ModelDriveItem(e));
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }
    return dataResult;
  }

  async getSharePoint(id: string): Promise<ModelSharePoint[]> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelSharePoint[] = [];

    try {
      const res = await this.presetAssociationRepository.getSharePoint(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map((e) => new ModelSharePoint(e));
        console.log('getSharePoint', id, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async createSharepoint(params: any): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelSharePoint[] = [];

    try {
      const res =
        await this.presetAssociationRepository.createSharepoint(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map((e) => new ModelSharePoint(e));
        console.log('postSharePoint', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }
  async deleteSharepoint(params: any): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelSharePoint[] = [];

    try {
      const res =
        await this.presetAssociationRepository.deleteSharepoint(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = (resData.data || []).map((e) => new ModelSharePoint(e));
        console.log('putSharepoint', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async postSharepointIndexing(params: any): Promise<any> {
    const { $functions } = useNuxtApp();
    let dataResult;

    try {
      const res =
        await this.presetAssociationRepository.postSharepointIndexing(params);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = resData.data;
        console.log('postSharepointIndexing', resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async getSharePointIndexing(id: string): Promise<ModelSharePointIndexing> {
    const { $functions } = useNuxtApp();
    let dataResult: ModelSharePointIndexing = new ModelSharePointIndexing();

    try {
      const res =
        await this.presetAssociationRepository.getSharePointIndexing(id);
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        dataResult = new ModelSharePointIndexing(resData.data);
        console.log('getSharePointIndexing', id, resData.data, dataResult);
      }
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }

    return dataResult;
  }

  async getDepartmentList(
    params: any
  ): Promise<IModelResponse<ModelDepartment[]>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelDepartment[]> = {
      data: [],
    };

    try {
      const res =
        await this.presetAssociationRepository.getDepartmentList(params);
      const resData = res.data.value;
      dataResult = (resData.data || []).map((e: any) => new ModelDepartment(e));
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }
    return dataResult;
  }

  async getUserList(
    params: any
  ): Promise<IModelResponse<ModelUser[] | Number>> {
    const { $functions } = useNuxtApp();
    let dataResult: IModelResponse<ModelUser[]> = {
      data: [],
    };

    try {
      const res = await this.presetAssociationRepository.getUserList(params);
      const resData = res.data.value;

      if (params.count) {
        return resData.totalItems || 0;
      }

      dataResult = (resData.data || []).map((e: any) => new ModelUser(e));
    } catch (err: any) {
      $functions.notify.error({
        text: err.message,
      });
      console.log(err, PresetAssociationService.name);
    }
    return dataResult;
  }
}
